<script setup lang="ts">
import VueMarkdown from 'vue-markdown-render';

const props = defineProps<{
  link: string;
  hero: {
    title: string;
    description: string;
    buttonCTA: string;
    backgroundImage: string;
  };
  themeKeys: {
    buttonBg: string;
    buttonFg: string;
    fg: string;
    bg: string;
  };
}>();
</script>

<template>
  <div
    class="relative lg:max-h-[600px]"
    :style="{
      color: props.themeKeys.fg,
      backgroundColor: props.themeKeys.bg
    }">
    <div class="relative px-4 py-4 md:px-8 md:py-8 xl:px-32 xl:py-24 overflow-hidden">
      <div class="z-10 inner-container flex flex-col items-start relative">
        <h1 class="text-5xl font-semibold mb-6 max-w-[40rem] md:mb-8">{{ props.hero.title }}</h1>
        <p
          class="text-2xl max-w-[40rem] 2xl:max-w-[55rem]"
        >
          <VueMarkdown :source="props.hero.description" :options="{ html: true }" />
        </p>
        <a
          :href="props.link"
          class="
            mt-8 md:mt-0 md:self-end font-semibold text-2xl
            rounded-2xl px-10 py-5 hover:shadow-xl
            cursor-pointer transition translate-y-0 lg:-translate-y-1/2 2xl:translate-y-0
          "
          :style="{
            backgroundColor: props.themeKeys.buttonBg,
            color: props.themeKeys.buttonFg,
          }"
        >
          {{ props.hero.buttonCTA }}
        </a>
        <NuxtImg
          class="absolute bottom-16 2xl:bottom-0 left-1/2 2xl:left-2/3 -z-10 h-3/5 md:h-4/5 xl:h-full"
          src="/logo-system.svg"
        />
      </div>
    </div>
  </div>
</template>
